var _path, _path2, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8666 18.6564L4.426 18.8264C-1.87841 16.481 -0.383378 10.4905 2.38426 8.67421C4.59838 7.22119 6.66456 7.78782 7.42088 8.25276C11.3814 0.527254 17.3019 1.65186 19.767 3.17984V8.25276H24.5954C28.6443 9.35838 28.8203 14.9916 26.4967 17.0688C25.6047 17.7253 24.7714 18.353 23.8666 18.6564Z",
    fill: "#FCAF04"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8659_1004",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 28,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8666 18.6564L4.426 18.8264C-1.87841 16.481 -0.383378 10.4905 2.38426 8.67421C4.59838 7.22119 6.66456 7.78782 7.42088 8.25276C11.3814 0.527254 17.3019 1.65186 19.767 3.17984V8.25276H24.5954C28.6443 9.35838 28.8203 14.9916 26.4967 17.0688C25.6047 17.7253 24.7714 18.353 23.8666 18.6564Z",
    fill: "#FCAF04"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8659_1004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.08917 7.89355C9.03502 8.17891 10.8466 9.41911 11.2369 11.5084C13.9229 11.5084 17.1453 16.1472 12.653 19.1746",
    stroke: "#B17C03",
    strokeWidth: 1.02382,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6896 8.05078C25.6244 11.256 25.4468 17.3101 18.6804 19.5359",
    stroke: "#B17C03",
    strokeWidth: 0.938504
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5671,
    y: 3.72559,
    width: 3.40849,
    height: 3.5076,
    fill: "#FCAF04"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.737,
    y: 3.41602,
    width: 2.4015,
    height: 2.47133,
    fill: "#FCAF04"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5085,
    y: 1.24219,
    width: 1.77044,
    height: 1.82192,
    fill: "#FCAF04"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4733,
    y: 1.51562,
    width: 1.08673,
    height: 1.11833,
    fill: "#FCAF04"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.737,
    y: 0.772461,
    width: 1.08673,
    height: 1.11833,
    fill: "#FCAF04"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4551,
    y: 0.166504,
    width: 0.82444,
    height: 0.848412,
    fill: "#FCAF04"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header_logo.5455ec030966a36967831fa2cdc82b80.svg";
export { ForwardRef as ReactComponent };